import { Component, Input, ViewChild } from '@angular/core';
import { ChargebacksTableViewComponent } from '../chargebacks-table-view/chargebacks-table-view.component';
import { StorageService } from '../../../core/storage/storageService';
import { UIHelpers } from '../../../core/ui-helpers';
import { TableView } from '../../ui/filterable-table/tableView';

@Component({
  selector: 'app-chargebacks-summary',
  templateUrl: './chargebacks-summary.component.html',
  standalone: false,
})
export class ChargebacksSummaryComponent {
  @Input() merchantId: string | undefined;

  @ViewChild('chargebacksTable') tableControl:
    | ChargebacksTableViewComponent
    | undefined;

  selectedMerchantId: string | undefined;
  tableView: any;
  //chargeback: ChargebackFacade | undefined;

  tableOptions: any = {
    selectAction: 'none',
  };

  constructor(
    public storage: StorageService,
    public uiHelper: UIHelpers,
  ) {
    if (storage.getCurrentUser() != undefined) {
      this.tableOptions.userId = storage.getCurrentUser()?.id;
    }

    this.tableView = new TableView(ChargebacksTableViewComponent);
  }

  ngOnInit() {
    if (this.merchantId) {
      this.tableOptions.merchantId = this.merchantId;
    }
  }

  ngAfterViewInit() {
    this.tableControl?.setOptions(this.tableOptions);
  }
}
